module.exports = __webpack_public_path__ + "./eddie_eb20e11dd85dbb37a769693bcdd85fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2014/eddie.png
// module id = 411
// module chunks = 0